<template>
  <PartnerInformationModal v-if="areMessagesAvailable"
                           :messages="messages"
                           @update-message="updateMessage"
                           @remove-modal-from-dom="removeAppFromDom">
  </PartnerInformationModal>
</template>

<script>
  import removeAppFromDom from '@common/mixins/removeAppFromDom';
  import PartnerInformationModal from './PartnerInformationModal.vue';
  import PartnerInformationService from './PartnerInformationService';

  export default {
    name: 'PartnerInformation',
    compatConfig: {
      MODE: 3,
    },
    components: { PartnerInformationModal },
    mixins: [removeAppFromDom],
    data() {
      return {
        messages: null,
      };
    },
    computed: {
      areMessagesAvailable() {
        return (this.messages !== null
          && this.messages !== undefined
          && this.messages.length !== 0);
      },
    },
    async mounted() {
      this.messages = await PartnerInformationService.getMessages();
    },
    methods: {
      updateMessage(messageId) {
        PartnerInformationService.updateMessage(messageId);
      },
    },
  };
</script>
